export default __webpack_public_path__ + "static/media/ContactInfo.597207d2.png";